export const YOUTUBE_URL_ORIGIN = "https://www.youtube.com";
export const YOUTUBE_CHANNEL_ID = "UCJlRjlukZiCk3YFuOP4sz9w";

export const YOUTUBE_ROUTE = {
  channel: "channel",
  watch: "watch",
  playlist: "playlist",
  embed: "embed",
};
export const YOUTUBE_URL_PARAM = {
  playlist: "list",
  video: "v",
};

export const YOUTUBE_CHANNEL_URL = YOUTUBE_URL_ORIGIN
  + "/" + YOUTUBE_ROUTE.channel
  + "/" + YOUTUBE_CHANNEL_ID;
